/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Manage_BillingInputs */

const en_settings_manage_billing = /** @type {(inputs: Settings_Manage_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Billing`)
};

const de_settings_manage_billing = /** @type {(inputs: Settings_Manage_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrechnung verwalten`)
};

const fr_settings_manage_billing = /** @type {(inputs: Settings_Manage_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérer la facturation`)
};

const es_settings_manage_billing = /** @type {(inputs: Settings_Manage_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionar facturación`)
};

const it_settings_manage_billing = /** @type {(inputs: Settings_Manage_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisci Fatturazione`)
};

const nl_settings_manage_billing = /** @type {(inputs: Settings_Manage_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beheer Facturering`)
};

const pl_settings_manage_billing = /** @type {(inputs: Settings_Manage_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarządzaj rozliczeniami`)
};

const fi_settings_manage_billing = /** @type {(inputs: Settings_Manage_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hallinnoi laskutusta`)
};

const da_settings_manage_billing = /** @type {(inputs: Settings_Manage_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrer fakturering`)
};

const sv_settings_manage_billing = /** @type {(inputs: Settings_Manage_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hantera Fakturering`)
};

/**
* | output |
* | --- |
* | "Manage Billing" |
*
* @param {Settings_Manage_BillingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_manage_billing = /** @type {((inputs?: Settings_Manage_BillingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Manage_BillingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_manage_billing(inputs)
	if (locale === "fr") return fr_settings_manage_billing(inputs)
	if (locale === "es") return es_settings_manage_billing(inputs)
	if (locale === "it") return it_settings_manage_billing(inputs)
	if (locale === "nl") return nl_settings_manage_billing(inputs)
	if (locale === "pl") return pl_settings_manage_billing(inputs)
	if (locale === "fi") return fi_settings_manage_billing(inputs)
	if (locale === "da") return da_settings_manage_billing(inputs)
	if (locale === "sv") return sv_settings_manage_billing(inputs)
	return en_settings_manage_billing(inputs)
});